import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/courseware-share/")({
  head: () => ({ meta: [{ title: "课件长图 · imiker CRM" }] }),
});
